// Module
var code = "<svg viewBox=\"0 0 1004 2008\"> <g class=\"root\"> <g class=\"background\"></g> <g class=\"content\"></g> <g class=\"work\"></g> <g class=\"sticker\"></g> <g class=\"foreground\"></g> </g> </svg> ";
// Exports
module.exports = code;